import React, { useState } from "react";
import OtpInput from "react-otp-input";

const VerificationCodeInput = ({ onChange }) => {
  const [otp, setOtp] = useState("");

  const handleChange = (value) => {
    setOtp(value);
    onChange(value); // Pozivamo onChange sa novom vrednošću OTP-a
  };

  return (
    <OtpInput
      value={otp}
      onChange={handleChange}
      numInputs={6}
      inputType="number"
      containerStyle={{ justifyContent: "space-between" }}
      renderSeparator={<span>-</span>} // Separator
      renderInput={(props) => (
        <input
          {...props}
          style={{
            width: "32px",
            height: "50px",
            textAlign: "center",
            fontSize: "20px",
            margin: "0 5px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />
      )}
    />
  );
};

export default VerificationCodeInput;
